import { render } from "./VerTiposPrestadores.vue?vue&type=template&id=a4d165ec"
import script from "./VerTiposPrestadores.vue?vue&type=script&lang=js"
export * from "./VerTiposPrestadores.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__